import { useRouter } from 'expo-router';
import { useState } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import TeamProfileFields from '@/components/FormFields/TeamProfileFields';
import WelcomeStepFrame, {
  WelcomeStepScrollContent,
} from '@/components/Welcome/WelcomeStepFrame';
import {
  WelcomeActions,
  WelcomePrimaryAction,
} from '@/components/Welcome/WelcomeUI';
import type { WelcomeFormValues } from '@/layouts/Welcome/form';
import { WELCOME_COMPLETION_ROUTE } from '@/layouts/Welcome/navigation';

export default function WelcomeTeamCreate() {
  const { navigate } = useRouter();
  const { control, setValue } = useFormContext<WelcomeFormValues>();
  const title = useWatch({ control, name: 'teamTitle' });
  const color = useWatch({ control, name: 'teamColor' });
  const localAvatarUrl = useWatch({ control, name: 'teamLocalAvatarUrl' });
  const tagGroupId = useWatch({ control, name: 'teamTagGroupId' });
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const isValid = title.trim().length > 0 && Boolean(tagGroupId);

  const onPressContinue = () => {
    const trimmedTitle = title.trim();

    if (!trimmedTitle) {
      setErrorMessage('Team name is required.');
      return;
    }

    if (!tagGroupId) {
      setErrorMessage('Sport is required.');
      return;
    }

    navigate(WELCOME_COMPLETION_ROUTE);
  };

  return (
    <WelcomeStepFrame
      title="Create your team"
      subtitle="Choose how this team appears in 1Time."
      footer={
        <WelcomeActions>
          <WelcomePrimaryAction
            label="Continue"
            disabled={!isValid}
            onPress={onPressContinue}
          />
        </WelcomeActions>
      }
    >
      <WelcomeStepScrollContent>
        <TeamProfileFields
          color={color}
          errorMessage={errorMessage}
          localAvatarUrl={localAvatarUrl}
          tagGroupId={tagGroupId}
          title={title}
          onChangeColor={(nextColor) => {
            setValue('teamColor', nextColor, {
              shouldDirty: true,
              shouldValidate: true,
            });
          }}
          onChangeTitle={(value) => {
            setValue('teamTitle', value, {
              shouldDirty: true,
              shouldValidate: true,
            });
          }}
          onChangeLocalAvatarUrl={(nextLocalAvatarUrl) => {
            setValue('teamLocalAvatarUrl', nextLocalAvatarUrl, {
              shouldDirty: true,
              shouldValidate: true,
            });
          }}
          onChangeTagGroupId={(nextTagGroupId) => {
            setValue('teamTagGroupId', nextTagGroupId, {
              shouldDirty: true,
              shouldValidate: true,
            });
          }}
        />
      </WelcomeStepScrollContent>
    </WelcomeStepFrame>
  );
}
